import { createAction } from '@reduxjs/toolkit';

export const setAirbnbPage = createAction('content/SET_AIRBNB_PAGE', (payload) => ({ payload }));
